// https://vuex.vuejs.org/en/getters.html
export default {
  currentBranch: state => state.currentBranch,
}
